import React from 'react';
import { Ruler, Calculator, Clock, PenTool, BookOpen, MessageSquare, Search, Globe, Hash, Coins } from 'lucide-react';
export function SubjectsGrid() {
  const subjects = [{
    title: 'Meten & Omrekenen',
    description: 'Lengte, gewicht, inhoud, oppervlakte en omtrek omrekenen.',
    icon: <Ruler className="w-6 h-6" data-id="element-204" />,
    color: 'text-blue-600',
    bg: 'bg-blue-50',
    border: 'border-blue-200'
  }, {
    title: 'Rekenen',
    description: 'Optellen, aftrekken, vermenigvuldigen, delen en breuken.',
    icon: <Calculator className="w-6 h-6" data-id="element-205" />,
    color: 'text-orange-600',
    bg: 'bg-orange-50',
    border: 'border-orange-200'
  }, {
    title: 'Getallen',
    description: 'Grote getallen, kommagetallen, afronden en getallenlijn.',
    icon: <Hash className="w-6 h-6" data-id="element-206" />,
    color: 'text-indigo-600',
    bg: 'bg-indigo-50',
    border: 'border-indigo-200'
  }, {
    title: 'Tijd',
    description: "Klokkijken analoog en digitaal, tijdsduur en schema's.",
    icon: <Clock className="w-6 h-6" data-id="element-207" />,
    color: 'text-teal-600',
    bg: 'bg-teal-50',
    border: 'border-teal-200'
  }, {
    title: 'Geld',
    description: 'Geld samenstellen, wisselgeld, prijzen en budgetteren.',
    icon: <Coins className="w-6 h-6" data-id="element-208" />,
    color: 'text-emerald-600',
    bg: 'bg-emerald-50',
    border: 'border-emerald-200'
  }, {
    title: 'Werkwoordspelling',
    description: "Stam bepalen, 't Kofschip, alle tijden en voltooid deelwoord.",
    icon: <PenTool className="w-6 h-6" data-id="element-209" />,
    color: 'text-rose-600',
    bg: 'bg-rose-50',
    border: 'border-rose-200'
  }, {
    title: 'Spelling & Grammatica',
    description: 'Klankregels, weetwoorden, leenwoorden en zinsontleding.',
    icon: <BookOpen className="w-6 h-6" data-id="element-210" />,
    color: 'text-purple-600',
    bg: 'bg-purple-50',
    border: 'border-purple-200'
  }, {
    title: 'Taalbegrip & Lezen',
    description: 'Begrijpend lezen, woordenschat en signaalwoorden.',
    icon: <MessageSquare className="w-6 h-6" data-id="element-211" />,
    color: 'text-pink-600',
    bg: 'bg-pink-50',
    border: 'border-pink-200'
  }, {
    title: 'Studievaardigheden',
    description: "Informatie opzoeken, kaartlezen, schema's en tabellen.",
    icon: <Search className="w-6 h-6" data-id="element-212" />,
    color: 'text-cyan-600',
    bg: 'bg-cyan-50',
    border: 'border-cyan-200'
  }, {
    title: 'Topografie',
    description: 'Topografie van Nederland, Europa en de wereld.',
    icon: <Globe className="w-6 h-6" data-id="element-213" />,
    color: 'text-green-600',
    bg: 'bg-green-50',
    border: 'border-green-200'
  }];
  return <section id="vakken" className="py-16 lg:py-24 bg-[#fffbf5]" data-id="element-214">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-215">
        <div className="max-w-2xl mb-16 text-center mx-auto" data-id="element-216">
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-950 mb-4 tracking-tighter" data-id="element-217">
            10 Vakgebieden, één platform 🚀
          </h2>
          <p className="text-lg text-slate-600" data-id="element-218">
            Alle content is afgestemd op het Nederlandse curriculum en doorloopt
            een 6-staps kwaliteitscontrole.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-219">
          {subjects.map((subject, index) => <div key={index} className={`${subject.bg} border ${subject.border} rounded-2xl p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group`} data-id="element-220">
              <div className={`w-12 h-12 rounded-xl bg-white flex items-center justify-center ${subject.color} shadow-sm mb-4 group-hover:scale-110 transition-transform`} data-id="element-221">
                {subject.icon}
              </div>
              <h3 className="text-base font-bold text-slate-950 mb-2" data-id="element-222">
                {subject.title}
              </h3>
              <p className="text-sm text-slate-700 leading-relaxed" data-id="element-223">
                {subject.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}